import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner, toast as sonnerToast } from "sonner";
import { Alert } from "./alert";
export const Toaster = () => {
    return (_jsx(Sonner, { className: "group ", position: "top-right", toastOptions: {
            classNames: {
                toast: "w-full",
            },
        } }));
};
export function toast({ kind, title, description, actions, autoHide = false, }) {
    return sonnerToast.custom((id) => {
        return (_jsx("div", { className: "relative rounded-md shadow-lg", children: _jsx(Alert, { kind: kind, title: title, description: description, actions: actions?.({ dismiss: () => sonnerToast.dismiss(id) }), onClose: () => sonnerToast.dismiss(id) }) }));
    }, { duration: autoHide ? 5000 : Number.POSITIVE_INFINITY });
}
function copyToClipboard(content) {
    return navigator.clipboard.writeText(content);
}
export const clickToCopy = async (e, copyText) => {
    e.preventDefault();
    e.stopPropagation();
    await copyToClipboard(copyText);
    toast({
        description: `${copyText} copied to clipboard`,
        kind: "info",
        autoHide: true,
    });
    return;
};
export const dismissToast = sonnerToast.dismiss;
